import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, withDefaults, watch } from 'vue';
interface IProps {
    modelValue?: boolean;
    text?: string;
    color: string;
    timeout: number;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AtomToast',
  props: {
    modelValue: { type: Boolean },
    text: {},
    color: {},
    timeout: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const model = ref<boolean>(false);
const props = __props;

const emit = __emit;
watch(
    () => props.modelValue,
    () => {
        model.value = props.modelValue;
    })
watch(
    () => model.value,
    () => {
        emit('update:modelValue', model.value);
    }
)    

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createBlock(_component_v_snackbar, {
    modelValue: model.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((model).value = $event)),
    timeout: props.timeout,
    color: props.color
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_v_btn, {
        color: "blue",
        variant: "text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (model.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Fechar ")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(props.text) + " ", 1)
    ]),
    _: 1
  }, 8, ["modelValue", "timeout", "color"]))
}
}

})